// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#app-sidebar[data-v-333cb95c]{display:flex}[data-v-333cb95c] .app-sidebar-tabs__content{overflow:hidden}[data-v-333cb95c] .app-sidebar-tabs__content section{height:100%;overflow-y:auto}.app-sidebar-tabs__content #tab-chat[data-v-333cb95c]{padding:0}\n", ""]);
// Exports
module.exports = exports;
